// NOTIFICATIONS
export const SHOW_NOTIFICATIONS_LOADING = "SHOW_NOTIFICATIONS_LOADING";
export const NOTIFICATIONS_LOADING_ERROR = "NOTIFICATIONS_LOADING_ERROR";
export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const NOTIFICATION_ERROR = "NOTIFICATION_ERROR";
export const READ_NOTIFICATION = "READ_NOTIFICATION";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const NOTIFICATIONS_ERROR = "NOTIFICATIONS_ERROR";
